import { render, staticRenderFns } from "./ContractsCompaniesPilver.vue?vue&type=template&id=0cae1c33&"
import script from "./ContractsCompaniesPilver.vue?vue&type=script&lang=js&"
export * from "./ContractsCompaniesPilver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports